import script from "./CommentBalloon.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentBalloon.vue?vue&type=script&setup=true&lang=js"

import "./CommentBalloon.vue?vue&type=style&index=0&id=b9c61ec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9c61ec2"]])

export default __exports__